/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LootboxRedemption,
    LootboxRedemptionFromJSON,
    LootboxRedemptionFromJSONTyped,
    LootboxRedemptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetLootboxRedemptionsResponse
 */
export interface GetLootboxRedemptionsResponse {
    /**
     * 
     * @type {Array<LootboxRedemption>}
     * @memberof GetLootboxRedemptionsResponse
     */
    lootboxRedemptions: Array<LootboxRedemption>;
}

export function GetLootboxRedemptionsResponseFromJSON(json: any): GetLootboxRedemptionsResponse {
    return GetLootboxRedemptionsResponseFromJSONTyped(json, false);
}

export function GetLootboxRedemptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLootboxRedemptionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lootboxRedemptions': ((json['lootboxRedemptions'] as Array<any>).map(LootboxRedemptionFromJSON)),
    };
}

export function GetLootboxRedemptionsResponseToJSON(value?: GetLootboxRedemptionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lootboxRedemptions': ((value.lootboxRedemptions as Array<any>).map(LootboxRedemptionToJSON)),
    };
}


